export default __webpack_public_path__ + "static/media/cake_layer_three.69d6fa90.svg";